import React, { useMemo } from "react";
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
} from "@tanstack/react-table";

export default function JCmonthTable({ serviceTypeWiseCountData }) {

    const data = useMemo(() => {
        return serviceTypeWiseCountData?.map((item) => ({
            division: item.key,
            complaintCount: item.doc_count,
        })) || [];
    }, [serviceTypeWiseCountData]);

    const columns = useMemo(() => [
        {
            accessorKey: "division",
            header: "Problem Area",
            cell: (info) => info.getValue(),
        },
        {
            accessorKey: "complaintCount",
            header: "Complaint Count",
            cell: (info) => info.getValue(),
        },
    ], []);

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="w-full border rounded overflow-hidden">
            {/* Table Head */}
            <table className="w-full table-fixed border border-gray-300 text-center">
                <thead className="bg-gray-200 text-xs">
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th
                                    key={header.id}
                                    className="border px-2 py-2 text-center break-words whitespace-normal"
                                    style={{ width: `${100 / table.getAllColumns().length}%` }}
                                >
                                    {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
            </table>

            {/* Scrollable Table Body */}
            <div
                style={{ maxHeight: "250px", overflowY: "auto", overflowX: "hidden" }}
                className="scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100"
            >
                <table className="w-full table-fixed border border-t-0 border-gray-300 text-center">
                    <tbody className="text-xs text-gray-700">
                        {table.getRowModel().rows.length > 0 ? (
                            table.getRowModel().rows.map((row, rowIndex) => (
                                <tr
                                    key={row.id}
                                    className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                >
                                    {row.getVisibleCells().map((cell) => {
                                        const value = cell.getValue()?.toString() || "";
                                        return (
                                            <td
                                                key={cell.id}
                                                className="border px-2 py-1 text-center break-words whitespace-normal"
                                                style={{ width: `${100 / table.getAllColumns().length}%` }}
                                                title={value}
                                            >
                                                {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext()
                                                )}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={columns.length}
                                    className="border px-2 py-4 text-center text-gray-500"
                                >
                                    No complaints data available.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
